import { Routes, Route } from "react-router-dom";

// Layouts
import MainLayout from "layouts";
import AccountLayout from "layouts/AccountLayout";
import HomeLayout from "layouts/HomeLayout";
import InsideLayout from "layouts/InsideLayout";
import OtherLayout from "layouts/OtherLayout";

// Errors
import NotFound from "views/errors/NotFound";

// Views
import Home from "views/home";
import Blocks from "views/blocks";
import BlockDetails from "views/blocks/[block]/detail";
import Transactions from "views/txs";
import TransactionDetails from "views/txs/detail";
import ContactUs from "views/footer/contact";
import TermsOfService from "views/footer/terms";
import PrivacyPolicy from "views/footer/policy";
import Address from "views/address";

const App = () => {
  return (
    <Routes>
      {/* Root layout */}
      <Route element={<MainLayout />}>
        {/* Home Layout */}
        <Route element={<HomeLayout />}>
          {/* Home page */}
          <Route path="/" element={<Home />} />
        </Route>

        {/* Account layout */}
        <Route element={<AccountLayout />}>
          {/* Address */}
          <Route path="/address/:address" element={<Address />} />
        </Route>

        {/* Inside layout */}
        <Route element={<InsideLayout />}>
          {/* Blocks */}
          <Route path="/blocks" element={<Blocks />} />
          <Route path="/block/:height" element={<BlockDetails />} />

          {/* Transactions */}
          <Route path="/txs" element={<Transactions />} />
          <Route path="/tx/:signature" element={<TransactionDetails />} />
        </Route>

        {/* Others */}
        <Route element={<OtherLayout />}>
          {/* Contact */}
          <Route path="/contact" element={<ContactUs />} />

          {/* Terms of service */}
          <Route path="/terms-of-service" element={<TermsOfService />} />

          {/* Privacy Policy */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Route>

        {/* Route Not Found */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default App;
